import moment from 'moment';

const RECORD_DATETIME_FORMAT = 'DD/MM/YY - HH:mm';

export const formatRecordDateTime = (datetime?: string) =>
  datetime ? moment(datetime).format(RECORD_DATETIME_FORMAT) : '';
